import Vue from 'vue'
import config from '@/config'
import axios from 'axios';

export const cdbService = {
  getState,
  getCity,
  getAllCitys,
  getAllCircos,
  searchCirco,
  searchCircoForCity
}

async function getState () {
  let url = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/'
  try {
    const { data } = await axios.get(url)
    return data
  } catch (error) {
    console.error(error)
  }
}

async function getCity (uf) {
  if (uf) {
    let url = `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
    try {
      const { data } = await axios.get(url)
      return data
    } catch (error) {
      console.error(error)
    }
  }
}

async function getAllCitys () {
  let url = 'https://servicodados.ibge.gov.br/api/v1/localidades/municipios'
  try {
    const { data } = await axios.get(url)
    return data
  } catch (error) {
    console.error(error)
  }
}

async function getAllCircos () {
  let url = 'https://api.circosdobrasil.com/v1/place/equipamento_list'
  try {
    const { data } = await axios.get(url)
    return data.equipamentos
  } catch (error) {
    console.error(error)
  }
}

async function searchCirco (payload) {
  let url = `https://api.circosdobrasil.com/v1/place/equipamento_query?search=${payload}`
  try {
    const { data } = await axios.get(url)
    return data.equipamentos
  } catch (error) {
    console.error(error)
  }
}

async function searchCircoForCity (payload) {
  let url = `https://api.circosdobrasil.com/v1/place/equipamento_cidade?search=${payload}`
  try {
    const { data } = await axios.get(url)
    return data.equipamentos
  } catch (error) {
    console.error(error)
  }
}